module.exports = __webpack_public_path__ + "img/Login Icon (1).b81bf911.svg";